import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const LogoutPage = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Выполняем выход
    logout();
    // Перенаправляем на страницу входа
    navigate('/login', { replace: true });
  }, [logout, navigate]);

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '80vh' }}>
      <p>Выход из системы...</p>
    </div>
  );
};

export default LogoutPage;


